import styled from 'styled-components';
import { layout } from '../../../config/styles';

export const Container = styled.div`
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 20px 0px;
  background-color: rgb(255, 255, 255);
  border-radius: ${layout.containerBorderRadius}px;
  margin: 15px;
  position: absolute;
  bottom: 25px;
  left: 25px;
  right: 25px;
  top: 25px;
`;
